import localDB from "./localDB";

let GLOBAL = require('./globals');

const StoreData = {
    async getInformation() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/store/admin-detail`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    updateInformation(data, res) {
        fetch(`${GLOBAL.BASE_URL}api/store/admin-detail`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => {
            res(responseData);
        }).catch((err) => {
            res({update: false})
        });
    },
    async get(slug) {
        const response = await fetch(`${GLOBAL.BASE_URL}api/store/${slug}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    },
    async list() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/stores/`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    },
    setup(data, res) {
        fetch(`${GLOBAL.BASE_URL}api/store/setup`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => {
            res(responseData);
        }).catch(() => {
            res({update: false})
        });
    },
};

export default StoreData;



// WEBPACK FOOTER //
// ./src/data/StoreData.js